module.exports = __webpack_public_path__ + "img/white-lily.008c83d4.jpg";